import React, { useCallback, useEffect } from 'react';
import MainLayout from '../../layouts/MainLayout';
import styles from '../../../styles/layout.module.css';
import { Breadcrumb, Button, Divider, Input, Row, Space, Spin, Typography } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import EditableField from '../../fields/EditableField';
import { deleteLocation, fetchLocation, updateLocation } from '../../../features/locations/locations.state';
import { DeleteOutlined, ShopTwoTone } from '@ant-design/icons';
import { useLocationByCode } from '../../../features/locations/locations.hooks';
import { CompanyLocation } from '../../../features/locations/locations.types';

const LocationPage: React.FC = () => {
  const { locationCode } = useParams() as { locationCode: string };
  const dispatch = useDispatch();
  const location = useLocationByCode(locationCode) as CompanyLocation;

  const handleDeleteButtonClick = useCallback(() => {
    dispatch(deleteLocation({ locationCode }));
  }, [dispatch, locationCode]);

  const handleLocationUpdate = useCallback(
    (data: Partial<CompanyLocation>) => {
      dispatch(updateLocation({ locationCode, data }));
    },
    [dispatch, locationCode]
  );

  return (
    <MainLayout>
      <div className={styles.mainGrid}>
        <div className={styles.breadCrumbs}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to='/settings/locations'>
                <Space>
                  <ShopTwoTone />
                  Локации
                </Space>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/settings/locations/${locationCode}`}>{location.name}</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={styles.contentArea}>
          <Typography.Title level={2} className={styles.title}>
            {location.name}
          </Typography.Title>
          <Space size='small' />
        </div>
        <div className={styles.sidebar}>
          <div className={styles.propertiesGrid}>
            <Typography.Text className={styles.title}>Валюта</Typography.Text>
            <EditableField value={location.currency}>
              <Input
                type='text'
                name='location'
                placeholder='Введите название валюты'
                onBlur={ev => handleLocationUpdate({ currency: ev.target.value })}
              />
            </EditableField>
            <Typography.Text className={styles.title}>Код</Typography.Text>
            <EditableField value={location.code}>
              <Input
                type='text'
                name='code'
                placeholder='Введите код локации'
                onBlur={ev => handleLocationUpdate({ code: ev.target.value })}
              />
            </EditableField>
          </div>
          <Divider />
          <Space direction='vertical' size='small'>
            <Button type='link' onClick={handleDeleteButtonClick} danger size='small' style={{ padding: 0 }}>
              <DeleteOutlined /> Удалить локацию
            </Button>
          </Space>
        </div>
      </div>
    </MainLayout>
  );
};

const LocationPageBlock: React.FC = () => {
  const { locationCode } = useParams() as { locationCode: string };
  const dispatch = useDispatch();
  const location = useLocationByCode(locationCode);

  useEffect(() => {
    dispatch(fetchLocation({ locationCode }));
  }, [dispatch, locationCode]);

  if (!location) {
    return (
      <Row align={'middle'} justify={'center'} style={{ minHeight: '100vh' }}>
        <Spin size={'large'} />
      </Row>
    );
  }

  return <LocationPage />;
};

export default LocationPageBlock;
